/* ==========================================================================
   SP TOOLS USA — HOME JS
   Loaded only when template == 'index'. Module skeletons only — bodies are
   populated when each homepage section ships. Preserve prototype IDs/classes.
   Source: itgeeksdesigner-…/script.js (relevant slices).

   The announcement-bar rotator lives in theme-global.js (global header section).
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {

    /* ======================================================================
       1. HERO SLIDER — fade autoplay (6s)
       Wired up when home-hero.liquid ships. Prototype: script.js §4.
       ====================================================================== */
    // TODO(home-hero): goToSlide / nextSlide / prevSlide; dots+arrows; autoplay
    // (section.settings.autoplay_delay_ms). Reset timer on interaction.
    // Honor prefers-reduced-motion (no autoplay).

    /* ======================================================================
       2. PRODUCT SLIDER — generalized [data-slider="<id>"] horizontal track
       Wired up when home-product-slider.liquid ships. Prototype: script.js §5.
       ====================================================================== */
    // TODO(product-slider): for each [data-slider] root, compute card step
    // (card.offsetWidth + gap), bind prev/next to translateX, reset on resize.
    // No autoplay. Multiple instances coexist via data-slider="<id>".

    /* ======================================================================
       3. MARQUEE CARD CLONES + explicit-width — testimonials + trusted-by-many
       The CSS @keyframes animate 0 → translate3d(-50%, 0, 0). For that to
       loop seamlessly the track must contain two identical sets of cards.
       Cloning in JS (vs. Liquid duplication) is deliberate: iOS Safari has
       a layout bug where `width: max-content` inside an overflow:hidden +
       mask-image parent is clamped to the viewport, breaking the -50%
       translation distance — but the clamp only happens at initial paint.
       Cloning after DOMContentLoaded forces iOS to recompute, and setting
       an explicit pixel width via inline style overrides max-content entirely.
       Prototype: script.js §5b, "TRUSTED BY MANY — auto-scroll" block.
       ====================================================================== */
    const setupMarquee = (trackId) => {
      const track = document.getElementById(trackId);
      if (!track || track.dataset.cloned) return;

      Array.from(track.children).forEach((card) => {
        const clone = card.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.tabIndex = -1;
        track.appendChild(clone);
      });
      track.dataset.cloned = '1';

      const setWidth = () => {
        const children = Array.from(track.children);
        if (children.length === 0) return;
        const gap = parseFloat(getComputedStyle(track).gap) || 0;
        const total = children.reduce((sum, c) => sum + c.offsetWidth, 0)
          + gap * Math.max(0, children.length - 1);
        track.style.width = total + 'px';
      };

      setWidth();

      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(setWidth, 150);
      });
    };

    setupMarquee('trustedTrack');
    setupMarquee('testimonialsTrack');

    /* ======================================================================
       7b. INTERACTION-DEFERRED IMAGES — Trusted by Many + Collection list
                                          + Featured collection + Image with text
       Images in these sections ship with data-src/data-srcset (see
       card-trusted.liquid, sections/collection-list.liquid, card-product.liquid
       rendered with defer_load: true, and sections/image-with-text.liquid) so
       the browser never fetches them at page load. On the first user interaction
       anywhere on the page (scroll, pointermove, click, keydown, touch) we swap
       data-src → src / data-srcset → srcset on every matching image — one shared
       loader for all these sections. This includes the Trusted marquee clones
       created in §3 above (cloneNode copies the data-* attributes). Fires once,
       then detaches every listener.
       ====================================================================== */
    const deferredImgSelector = 'img.trusted-card-img[data-src], img.category-media-img[data-src], img.product-media-img[data-src], img.cta-banner-img[data-src]';

    const loadDeferredImages = () => {
      document.querySelectorAll(deferredImgSelector).forEach((img) => {
        const srcset = img.getAttribute('data-srcset');
        if (srcset) {
          img.setAttribute('srcset', srcset);
          img.removeAttribute('data-srcset');
        }
        img.setAttribute('src', img.getAttribute('data-src'));
        img.removeAttribute('data-src');
      });
    };

    if (document.querySelector(deferredImgSelector)) {
      const interactionEvents = ['scroll', 'pointermove', 'pointerdown', 'click', 'keydown', 'touchstart', 'wheel'];
      const onFirstInteraction = () => {
        loadDeferredImages();
        interactionEvents.forEach((evt) =>
          window.removeEventListener(evt, onFirstInteraction, { passive: true })
        );
      };
      interactionEvents.forEach((evt) =>
        window.addEventListener(evt, onFirstInteraction, { passive: true, once: true })
      );
    }

    /* ======================================================================
       4. REEL + BRAND-STORY VIDEO — lazy load
       lazy-video.liquid emits <video data-src="…">; we swap data-src → src
       when each video nears the viewport, then call play() once canplay fires
       (handles browsers that block autoplay until the element is hydrated).
       Source: itgeeksdesigner-…/script.js §5c.
       ====================================================================== */
    const lazyVideos = document.querySelectorAll('video[data-src]');

    const loadLazyVideo = (video) => {
      const src = video.getAttribute('data-src');
      if (!src) return;
      video.setAttribute('src', src);
      video.removeAttribute('data-src');
      video.addEventListener('canplay', () => {
        const p = video.play();
        if (p && typeof p.catch === 'function') p.catch(() => {});
      }, { once: true });
      video.load();
    };

    if (lazyVideos.length > 0 && 'IntersectionObserver' in window) {
      const videoObserver = new IntersectionObserver((entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            loadLazyVideo(entry.target);
            obs.unobserve(entry.target);
          }
        });
      }, { rootMargin: '200px 0px' });
      lazyVideos.forEach((v) => videoObserver.observe(v));
    } else {
      lazyVideos.forEach(loadLazyVideo);
    }

    /* Sound exclusivity for .reel-sound-btn (also used by .brand-story-sound-btn).
       Clicking toggles muted on the sibling <video>; unmuting one mutes every
       other video on the page so only one plays sound at a time. */
    const setSoundBtnIcon = (btn, muted) => {
      const icon = btn.querySelector('i');
      if (!icon) return;
      icon.classList.toggle('ph-speaker-slash', muted);
      icon.classList.toggle('ph-speaker-high', !muted);
    };

    const muteAllVideosExcept = (exceptVideo) => {
      document.querySelectorAll('video').forEach((v) => {
        if (v === exceptVideo) return;
        v.muted = true;
        const parent = v.parentElement;
        if (!parent) return;
        const otherBtn = parent.querySelector('.reel-sound-btn');
        if (otherBtn) setSoundBtnIcon(otherBtn, true);
      });
    };

    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.reel-sound-btn');
      if (!btn) return;
      const parent = btn.parentElement;
      if (!parent) return;
      const video = parent.querySelector('video');
      if (!video) return;

      const willUnmute = video.muted;
      if (willUnmute) muteAllVideosExcept(video);
      video.muted = !willUnmute;
      setSoundBtnIcon(btn, !willUnmute);
      const p = video.play();
      if (p && typeof p.catch === 'function') p.catch(() => {});
    });

    /* ======================================================================
       5. QUICK-ADD → handled globally in theme-global.js §8 (delegated click
       on .product-quick-add[data-variant-id]). Sitewide, not home-specific.
       ====================================================================== */

    /* ======================================================================
       6. WISHLIST — visual toggle placeholder
       Wired up when theme-card-product is interactive. Prototype: script.js §9.
       Real wishlist integration (Wishlist Plus / Klaviyo) is a separate task.
       ====================================================================== */
    // TODO(card-product): toggle .ph ↔ .ph-fill on .product-wishlist click;
    // store id in sessionStorage as a placeholder until the app is chosen.

    /* ======================================================================
       7. TRUSTED AMBASSADOR MODAL — open from card, populate from data-attrs
       Wired up when home-trusted-by-many.liquid ships.
       Prototype: script.js "TRUSTED AMBASSADOR MODAL" block.
       ====================================================================== */
    // TODO(home-trusted-by-many): .trusted-card click → openTrustedModal()
    // populates #trustedModalImg/Name/Role/Bio from card.dataset.*; ESC and
    // overlay close. Focus trap inside modal while open.

});



const timer = setInterval(() => {
  const embed = document.querySelector("shopify-forms-embed#app-embed");

  if (embed?.shadowRoot) {
    clearInterval(timer);

    const style = document.createElement("style");
    style.textContent = `
      fieldset._checkboxFieldSet_1hja3_3 legend {
        display: none !important;
      }
    `;

    embed.shadowRoot.appendChild(style);
  }
}, 200);